import Page from "../Common/Page";
import React from "react";
import { Form, Input, Button, Row, Col, Divider, Alert, Space } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { Messages } from "../Common/ValidateMessages";
import { http } from "../Common/http";
import withRouterDom from "../Common/WithReactRouterDom";
import { Params } from "react-router-dom";
import "../Style/Password.css";

type FormData = {
  password: string;
  old_password: string;
};

interface Props {
  // cookies: Cookies;
  params: Readonly<Params<string>>;
}

interface PostData {
  Id: string;
  Password: string;
}

class PasswordPage extends React.Component<Props> {
  state = {
    loginError: "none",
    loginErrorMsg: "",
    buttonDisabled: true,
  };
  private _page: React.RefObject<Page>;

  constructor(props: Props) {
    super(props);
    this._page = React.createRef<Page>();
  }

  submitForm = async (data: FormData) => {
    this.setState({ loginError: "none" });
    this.setState({ loginErrorMsg: "" });
    this._page.current?.setState({ isPageLoading: true });

    try {
      const { params } = this.props;
      const reminderData: PostData = {
        Id: params.Id || "",
        Password: data.password,
      };
      //var id = useParams<{ id: string }>();
      const result = await http<undefined, PostData>({
        path: "/Password",
        method: "post",
        body: reminderData,
        noResponsebody: true,
      });
      if (result.ok) {
        this.setState({ loginError: "none" });
        window.location.replace("/Completed");
      } else {
        if (result.statusCode === 400) {
          this.setState({ loginErrorMsg: Messages["ERR-038"] });
          this.setState({ loginError: "" });
        } else {
          this.setState({ loginErrorMsg: Messages["ERR-040"] });
          this.setState({ loginError: "" });
        }
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      this.setState({ loginErrorMsg: Messages["ERR-040"] });
      this.setState({ loginError: "" });
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  onFormValueChange = () => {
    this.setState({ loginError: "none" });
  };

  async componentDidMount() {
    this.setState({ loginError: "none" });
    this.setState({ loginErrorMsg: "" });
    this._page.current?.setState({ isPageLoading: true });

    try {
      const { params } = this.props;
      const result = await http<undefined>({
        path: "/Password/ChecPwdUrlExpirationDatetimeIdExisted/" + params.Id,
        method: "get",
        noResponsebody: true,
      });
      if (result.ok) {
        this.setState({ loginErrorMsg: "" });
        this.setState({ loginError: "none" });
        this.setState({ buttonDisabled: false });
      } else {
        this.setState({ loginErrorMsg: Messages["ERR-040"] });
        this.setState({ loginError: "" });
        this.setState({ buttonDisabled: true });
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      this.setState({ loginErrorMsg: Messages["ERR-040"] });
      this.setState({ loginError: "" });
      this.setState({ buttonDisabled: true });
      this._page.current?.setState({ isPageLoading: false });
    }
  }

  // validator
  validatorIsPassword = async (_: any, value: string): Promise<void> => {
    const pattern = {
      password: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[!-~]{8,30}$/,
    };
    if (
      value !== undefined &&
      value != null &&
      value.length <= 30 &&
      !value.match(pattern.password)
    ) {
      // TODO メッセージ
      return Promise.reject(new Error(Messages["ERR-038"]));
    }
    return Promise.resolve();
  };

  render() {
    return (
      <Page ref={this._page} noCheckAuthority={true}>
        <Row justify="center">
          <Col span={12}>
            <h1 className="iiscore-title">iiscore-U</h1>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={12}>
            <Divider orientation="left">パスワード変更</Divider>
          </Col>
        </Row>
        <Row justify="center" style={{ display: this.state.loginError }}>
          <Col span={12}>
            <Alert
              type="error"
              description={this.state.loginErrorMsg}
              message="エラー"
            />
          </Col>
        </Row>

        <Row justify="center">
          <Col span={8}>
            <Form
              name="password"
              layout="vertical"
              onFinish={this.submitForm}
              onValuesChange={this.onFormValueChange}
              autoComplete="off"
              className="login-form"
            >
              <Form.Item
                name="password"
                label="新しいパスワード"
                rules={[
                  { required: true },
                  { max: 30 },
                  { min: 8 },
                  { validator: this.validatorIsPassword },
                ]}
              >
                <Input.Password
                  style={{ width: "400px" }}
                  size="middle"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="パスワード"
                  maxLength={30}
                />
              </Form.Item>
              <Form.Item
                name="confirm"
                label="パスワード確認"
                dependencies={["password"]}
                rules={[
                  { required: true },
                  // { max: 30 },
                  // { min: 8 },
                  // { validator: this.validatorIsPassword },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error(Messages["ERR-014"]));
                    },
                  }),
                ]}
              >
                <Input.Password
                  style={{ width: "400px" }}
                  size="middle"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="パスワード"
                  maxLength={30}
                />
              </Form.Item>

              <br />
              <Form.Item>
                <Space split={<Divider type="vertical" />} size={"large"}>
                  <Button
                    size="middle"
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                    disabled={this.state.buttonDisabled}
                  >
                    確認する
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </Col>
          <Col span={6}>
            <Row>
              <Col>
                <div id={"PolicyClolor"} style={{ padding: "0 24px 24px" }}>
                  <h3 id={"PolicyClolor"}>パスワードポリシー</h3>
                  <ul style={{ padding: "0 24px 0px" }}>
                    <li>英字：最低大文字1文字以上を含む</li>
                    <li>英字：最低小文字1文字以上を含む</li>
                    <li>数字：最低1文字を含む</li>
                    <li>長さ：最低8文字以上30文字まで</li>
                    <li>文字種：半角文字</li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Page>
    );
  }
}
export default withRouterDom(PasswordPage);
